import React from "react";

import FallbackImage from "./FallbackImage";
import defaultBanner from "../assets/images/default_image.svg";

const LibraryMediaTile = ({
  className = "content-main-image__item",
  paths = [],
  onClick,
  children,
}) => (
  <div className={className} onClick={onClick}>
    <div className="library-tile__media">
      <FallbackImage
        variant="fill"
        paths={paths}
        fallback={defaultBanner}
        alt=""
      />
    </div>
    {children}
  </div>
);

export default LibraryMediaTile;
